<template>
  <span
    @click="bcMenuStore.openMenu2()"
    class="inline-flex cursor-pointer hover:text-gray-800 | relative -right-2 | sm:static"
  >
    <aw-icon icon="dots" class="w-5 h-5 "></aw-icon>
  </span>
  <teleport to="#LeftNavMobile2">
    <slot />
  </teleport>
</template>

<script>
import useBcMenu from '@/frontapp/store/bcMenu'
import { mapStores } from 'pinia'

export default {
  computed: {
    ...mapStores(useBcMenu)
  },
  beforeUnmount() {
    this.bcMenuStore.closeMenu2()
  }
};
</script>

<style lang="scss" scoped></style>
